/**
 * Validate form settings
 */

 /**
  * Returns
  * { valid: <true/false>, msg: 'some error message', id: <id of failed data>}
  * success looks like { valid: true, msg: '', id: null}
  * failure looks like { valid: false, msg: 'enter a name', id: 'session-name'}
  * Unknown field id's return true
  * @param {*} id
  * @param {*} value
  */
 const validateField = (id, value) =>{
	//console.log('id', id)
	//console.log('value', value)
	//console.log('type', typeof value)
	let valueTxt = ''
	if (typeof value === 'number'){
		valueTxt = value.toString()
	} else {
		valueTxt = value
	}

	let valid = true
	let msg = ''
	let pattern = null
	switch (id){
		case 'SessionName':
			//pattern = '^[a-zA-Z\'"]+[a-z#A-Z0-9/_ -\'"]+$'
			//pattern = '^[a-z#A-Z0-9/_ -\'"]+$'
			// if (valueTxt.length < 4 || !valueTxt.match(pattern)){
			// 	valid = false
			// 	msg = 'Enter a valid \'Session Name\'. Must contain letters, numbers, spaces or \' # - _ /'
			// }
			if (valueTxt.length < 1) {
				valid = false
				msg = 'Enter a \'Session Name\'.'
			}
			break;
		//case 'SessionStartObj':
		//:FIX:
		case 'Head':
			pattern = '^[0-9]+$'
			if (!valueTxt.match(pattern) || parseInt(valueTxt) <= 0){
				valid = false
				msg = 'Enter \'Number of head\' estimate'
			}
			break;
		case 'BreedType':
			if (valueTxt === undefined || valueTxt === ''){
				valid = false
				msg = 'Select \'Breed\''
			}
			break;
		case 'Sex':
			if (valueTxt === undefined || valueTxt === ''){
				valid = false
				msg = 'Select \'Sex\''
			}
			break;
		case 'Age':
			if (valueTxt === undefined || valueTxt === ''){
				valid = false
				msg = 'Select \'Age\''
			}
			break;
		case 'Size':
			if (valueTxt === undefined || valueTxt === ''){
				valid = false
				msg = 'Select \'Size\''
			}
			break;

		case 'Weigher':
			pattern = '^[0-9]+$'
			if (!valueTxt.match(pattern) || parseInt(valueTxt) <= 0){
				valid = false
				msg = 'No Weigher ID selected'
			}
			break;

		case 'Paddock':
			pattern = '^[0-9.]+$'
			if (!valueTxt.match(pattern) || parseInt(valueTxt) <= 0){
				valid = false
				msg = 'Enter \'Paddock size\' estimate'
			}
			break;
		default://fallthrough
	}
	return { valid: valid, msg: msg, id: id}
}

export const validateAllFields = (values) =>{
	const field_ids = ['Weigher', 'SessionName', 'SessionStart','Head', 'BreedType', 'Sex', 'Age', 'Size','Paddock']
	let id = null
	try {
		for (let i = 0; i < field_ids.length; i++) {
			id = field_ids[i]
			const resp = validateField(id, values[id])
			if (resp.valid === false){
				return resp
			}
		}
	} catch (error) {
		//console.log('error',error)
		return { valid: false, msg: `${id} not set`, id: id}
	}
	return { valid: true, msg: '', id: null}
}